
















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import HolidaysBookingDetails from "../holidays/HolidaysBookingDetails.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson from "../../shared/HolidayProgramBookingJson";
import { HolidayProgramWithBookingsJson } from "../../shared/HolidayProgramJson";
import { HolidayProgramWithBookingJson } from "../../shared/HolidayProgramJson";
import { HolidayProgramBookingStatus } from "../../shared/HolidayProgramBookingStatus";

import CustomerJson from "../../shared/CustomerJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "HolidaysOverview",
  components: {
    Loading,
    TableView,
    HolidaysBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    HolidayProgramBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allHolidayPrograms: null as HolidayProgramJson[] | null,
      attentionalHolidayBookings: null as HolidayProgramWithBookingJson[] | null,
      attentionalHolidayBookingsMoreAvailable: null as boolean | null,
      selectedHolidayProgramId: null as number | null,
      selectedHolidayBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: HolidayProgramWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedHolidayProgramId = item.ID;
        this.selectedHolidayBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },

    loadData() {
      this.loadAttentionalHolidayBookings();
    },

    async loadAttentionalHolidayBookings(loadMore: null = null) {
      var states = [HolidayProgramBookingStatus.pending, HolidayProgramBookingStatus.waitingList];
      var afterDateTime = null;

      //load more
      if (loadMore && this.attentionalHolidayBookings != null) {
        this.attentionalHolidayBookingsMoreAvailable = null;

        let lastBooking = this.attentionalHolidayBookings[this.attentionalHolidayBookings.length - 1].booking;

        afterDateTime = new Date(lastBooking.bookingDateTime);
      } else {
        this.attentionalHolidayBookings = null;
      }

      //final load holidays
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getAggregatedHolidayProgramBookings(states, true, afterDateTime);

          if (loadMore && this.attentionalHolidayBookings != null) {
            this.attentionalHolidayBookings = this.attentionalHolidayBookings.concat(bookings.holidayProgramBookings);
          } else {
            this.attentionalHolidayBookings = bookings.holidayProgramBookings;
          }

          this.attentionalHolidayBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadData();
    },

    getAllChildNames(customers: CustomerJson[]) {
      var childs = "";

      for (let i = 0; i < customers.length; i++) {
        if (i != 0) {
          childs += ", ";
        }
        childs += customers[i].childFirstName;
        childs += " ";
        childs += customers[i].childLastName;
      }

      return childs;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    holidayColumns: function (): TableViewColumnDefinitions<HolidayProgramWithBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Ferienprogramm",
          td: (i) => i.title,
        },
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.booking.customers.length > 0
              ? i.booking.customers[0].guardianLastName + ", " + i.booking.customers[0].guardianFirstName
              : "--",
        },
        {
          th: "Anzahl Kinder",
          td: (i) => i.booking.customers.length,
        },
        {
          th: "Kinder",
          td: (i) => (i.booking.customers.length > 0 ? vue.getAllChildNames(i.booking.customers) : "--"),
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.booking.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.HolidayProgramBookingStatusNames[i.booking.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<HolidayProgramWithBookingJson>[];
    },
  },
});
